import Typography from '../../DataDisplay/Typography/Typography.js';
import Tooltip from '../../Layout/Tooltip/Tooltip.js';
import React__default from 'react';
import ButtonIcon from '../ButtonIcon/ButtonIcon.js';
import Stack from '../../DataDisplay/Stack/Stack.js';
import '../../DataDisplay/Table/Table.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../../styles/forms.css.js';
import '../../../styles/fonts.css.js';
import 'classnames';
import '../Button/Button.module.scss.js';

const Label = ({ tag = 'textsmall', labelDisplayStyle = 'icon', marginTop = 0, marginBottom = 5, onClick, ...props }) => {
    const LabelIcon = () => {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { tag: tag },
                React__default.createElement("div", { style: { marginBottom: marginBottom, marginTop: marginTop } },
                    React__default.createElement(Stack, { direction: "row", gap: 3 },
                        React__default.createElement("div", { style: {
                                display: 'inline-block',
                                cursor: onClick ? 'pointer' : undefined,
                            }, onClick: onClick }, props.children),
                        props.tooltipMessage && labelDisplayStyle === 'icon' && (React__default.createElement("sup", null,
                            React__default.createElement(ButtonIcon, { size: "extra-small", hoverType: "none", icon: "IconInformation", tooltipMessage: props.tooltipMessage, tooltipColor: props.tooltipStyle }))))))));
    };
    const LabelDashed = () => {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { style: { marginBottom: marginBottom, marginTop: marginTop } }, props.tooltipMessage ? (React__default.createElement(Tooltip, { title: props.tooltipMessage, color: props.tooltipStyle },
                React__default.createElement("div", { style: {
                        display: 'inline-block',
                        cursor: onClick ? 'pointer' : undefined,
                    }, onClick: onClick },
                    React__default.createElement(Typography, { tag: tag },
                        React__default.createElement("div", { style: { borderBottom: 'dashed 1px #CCCCCC' } }, props.children))))) : (React__default.createElement(Typography, { tag: tag },
                React__default.createElement("div", null, props.children))))));
    };
    return labelDisplayStyle === 'underline' ? React__default.createElement(LabelDashed, null) : React__default.createElement(LabelIcon, null);
};

export { Label as default };
//# sourceMappingURL=Label.js.map
